import axios from 'axios';
import API_URL from '../constant';

export function requestTestimonial() {
    return axios.request({
        method: 'get',
        url: API_URL + "comments"

    })
}